module.exports = __webpack_public_path__ + "static/media/logo-dark.7ed98b56.png";